import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutList, Mail, Settings2, Inbox, Users, Settings, FileCode, LogOut, Shield, Send, Clock, List, Tag, Database, Key, UserCircle } from 'lucide-react';
import { useWorkspace } from '../contexts/WorkspaceContext';
const navigation = [{
  name: 'Mailing Lists',
  href: '/mailing-lists',
  icon: Database
}, {
  name: 'Newsletters',
  href: '/newsletters',
  icon: List
}, {
  name: 'Contacts',
  href: '/contacts',
  icon: UserCircle
}, {
  name: 'Signup Forms',
  href: '/forms',
  icon: LayoutList
}, {
  name: 'Email Templates',
  href: '/templates',
  icon: Mail
}, {
  name: 'Form Configuration',
  href: '/configurations',
  icon: Settings2
}, {
  name: 'Tags',
  href: '/tags',
  icon: Tag
}, {
  name: 'Campaigns',
  href: '/campaigns',
  icon: Send
}, {
  name: 'Send Buckets',
  href: '/send-buckets',
  icon: Database
}, {
  name: 'Submissions',
  href: '/submissions',
  icon: Inbox
}, {
  name: 'Subscriptions',
  href: '/subscriptions',
  icon: Users
}, {
  name: 'Audit Log',
  href: '/audit-log',
  icon: Clock
}, {
  name: 'Team Users',
  href: '/users',
  icon: Users
}, {
  name: 'Roles & Permissions',
  href: '/roles',
  icon: Key
}, {
  name: 'Settings',
  href: '/settings',
  icon: Settings
}];
export function Sidebar() {
  const location = useLocation();
  const {
    currentUser
  } = useWorkspace();
  return <div className="flex flex-col w-64 flex-shrink-0 border-r border-gray-200 bg-white h-screen sticky top-0" data-id="element-354">
      {/* Logo - Fixed height */}
      <div className="flex h-16 items-center px-6 border-b border-gray-200 flex-shrink-0" data-id="element-355">
        <div className="flex items-center gap-2 font-semibold text-gray-900" data-id="element-356">
          <FileCode className="h-6 w-6 text-blue-600 flex-shrink-0" data-id="element-357" />
          <span className="truncate" data-id="element-358">ConfigConsole</span>
        </div>
      </div>

      {/* Navigation - Scrollable */}
      <nav className="flex-1 overflow-y-auto px-3 py-4" data-id="element-359">
        <div className="space-y-1" data-id="element-360">
          {navigation.map(item => {
          const isActive = location.pathname === item.href || location.pathname.startsWith(item.href + '/');
          if (item.href === '/roles' && currentUser.role !== 'Super Admin') {
            return null;
          }
          return <Link key={item.name} to={item.href} className={`group flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap ${isActive ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-361">
                <item.icon className={`mr-3 h-5 w-5 flex-shrink-0 ${isActive ? 'text-gray-900' : 'text-gray-400 group-hover:text-gray-500'}`} data-id="element-362" />
                <span className="truncate" data-id="element-363">{item.name}</span>
              </Link>;
        })}

          {currentUser.role === 'Super Admin' && <Link to="/super-admin" className={`group flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors mt-6 whitespace-nowrap ${location.pathname.startsWith('/super-admin') ? 'bg-purple-50 text-purple-900' : 'text-purple-600 hover:bg-purple-50 hover:text-purple-900'}`} data-id="element-364">
              <Shield className="mr-3 h-5 w-5 flex-shrink-0" data-id="element-365" />
              <span className="truncate" data-id="element-366">Super Admin</span>
            </Link>}
        </div>
      </nav>

      {/* User section - Fixed at bottom */}
      <div className="border-t border-gray-200 p-4 flex-shrink-0" data-id="element-367">
        <div className="flex items-center gap-3 px-3 py-2" data-id="element-368">
          <div className="h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center text-xs font-medium text-gray-600 flex-shrink-0" data-id="element-369">
            {currentUser.name.charAt(0)}
          </div>
          <div className="flex-1 min-w-0" data-id="element-370">
            <p className="text-sm font-medium text-gray-900 truncate" data-id="element-371">
              {currentUser.name}
            </p>
            <p className="text-xs text-gray-500 truncate" data-id="element-372">{currentUser.role}</p>
          </div>
          <button className="text-gray-400 hover:text-gray-600 flex-shrink-0" data-id="element-373">
            <LogOut className="h-4 w-4" data-id="element-374" />
          </button>
        </div>
      </div>
    </div>;
}